import i18n from '@/constants/i18n';

type FormatPriceOptions = {
  currency?: string;
  locale?: string;
  showCents?: boolean;
  showCurrency?: boolean;
};

export function formatPrice(price: number, options?: FormatPriceOptions) {
  const {
    locale = i18n.language,
    currency = 'USD',
    showCents = false,
    showCurrency = false,
  } = options || {};

  const formattedPrice = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || 'USD',
    currencyDisplay: showCurrency ? 'code' : 'narrowSymbol',
    minimumFractionDigits: showCents || price % 1 > 0 ? 2 : 0,
  }).format(price);

  if (showCurrency) return formattedPrice;
  return formattedPrice.replace(/[a-zA-Z]/g, '').trim();
}
